import { TIntervalListnerPayload } from "src/sagas/intervalListener";

export const REDIRECT_TO_LOGOUT_ACTION = "REDIRECT_TO_LOGOUT_ACTION";
export const redirectToLogoutAC = (data: TIntervalListnerPayload) => ({
    type: REDIRECT_TO_LOGOUT_ACTION,
    payload: data,
});